/* eslint-disable react/prop-types */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import routes from '../routes';

export default class SuccessForm extends React.Component {
  onClickHome = () => {
    this.props.setCorrectData({ correctDataState: 'changed' });
    this.props.setForm({ form: 'userForm' });
  }

  onClickProgress = () => {
    this.props.getTokenSt(this.props.token);
  }

  render() {
    return <div className="col-12">
<div className="card text-center">
<div className="card-header">
  Rhx imapSync
</div>
<div className="card-body">

  <h5 className="card-title">Sync avviata</h5>
  <div>
  <h1 className="display-1"><FontAwesomeIcon icon="sync" /></h1>
  <p className="card-text">{ this.props.message }</p>
  </div>
  <div className='row justify-content-center mt-1'>
  <div className="col-md-2 d-none d-md-block">
  <button type="button" className="btn btn-dark" onClick={this.onClickHome}><FontAwesomeIcon icon="home" /> Torna sulla Home</button>
  </div>
  <div className="col d-md-none ">
  <button type="button" className="btn btn-dark" onClick={this.onClickHome}><FontAwesomeIcon icon="home" /></button>
  </div>
  <div className="col-md-2 d-none d-md-block">
  <a className="btn btn-dark" href={routes.tokenProgressUrl(this.props.token)}><FontAwesomeIcon icon="hourglass-half" /> Controlla avanzamento</a>
  </div>
  <div className="col d-md-none ">
  <a className="btn btn-dark" href={routes.tokenProgressUrl(this.props.token)}><FontAwesomeIcon icon="hourglass-half" /></a>
  </div>
  </div>
</div>
<div className="card-footer text-muted">
 Rhx
</div>
</div>
</div>;
  }
}
